import BlankEventItem from 'components/atoms/BlankEventItem'
import FeedbackItemContainer from 'components/atoms/container/FeedbackItemContainer'
import ActivityListContainer from 'components/molecules/home/ActivityListContainer'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { CHECK_IN_SURVEY } from 'routes/constants'
import { USER_CALENDAR_EVENTS_URL } from 'services/constants'
import colors from 'styles/colors'
import { getRequest } from 'utils/api'
import ChecklistIcon from '@mui/icons-material/Checklist'

const backgroundColor = colors.GoldenYellow50
const CheckInList = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [checkInList, setCheckInList] = useState([])

  const minDateTime = moment.utc().toISOString()
  useEffect(() => {
    const fetchData = async () => {
      const res = await getRequest(USER_CALENDAR_EVENTS_URL, {
        minDateTime,
        checkInSurveyOpen: true
      })
      if (res?.status === 200) {
        setCheckInList(res.data.data.data)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ActivityListContainer
      title={t('feedbackArea.checkInTitle')}
      icon={<ChecklistIcon />}
      itemCount={checkInList.length}
      listTitle={t('home.in24Hours')}
      backgroundColor={backgroundColor}>
      {checkInList.length > 0 ? (
        <>
          {checkInList.map(e => {
            const dueTime = moment.utc(e.startTime).diff(moment(), 'hours')
            const time = moment.utc(e.startTime).local().format('hh:mm A')
            return (
              <FeedbackItemContainer
                backgroundColor={backgroundColor}
                key={`check-in-${e.id}`}
                updatedStyle={true}
                user={e.userConnectionEvent.userConnection.connectedBy}
                subHeader={t('feedbackArea.dueInHours', {
                  hours: dueTime,
                  time
                })}
                acceptLabel={t('feedbackArea.checkInSurvey')}
                acceptAction={() =>
                  navigate(CHECK_IN_SURVEY, {
                    state: {
                      userCalendarEventId: e.id
                    }
                  })
                }
              />
            )
          })}
        </>
      ) : (
        <BlankEventItem
          showConfirm={true}
          description={t('feedbackArea.noOpenCheckIn')}
        />
      )}
    </ActivityListContainer>
  )
}

export default CheckInList
